<template>
	<div class="full login_container flex" style="background-color: white;" v-if="!appconfig.dingtalk">
		<template v-if="device!='pc'">
			<div class="phonebox">
				<div v-if="!logincompany && appconfig.logincompany.length > 1">
					<van-divider>选择主体</van-divider>
					<div>
						<van-button v-for="(item,index) in appconfig.logincompany" :key="index" style="width: 100%;margin: 0;margin-bottom: 10px;" @click="companyChange(item)" block>{{item.title}}</van-button>
					</div>
				</div>
				<div v-else>
					<van-divider>{{title}}</van-divider>
					<div ref="login_form" style="margin-bottom: 60px;"></div>
					<van-button v-if="appconfig.logincompany.length > 1"  type="danger" @click="logincompany = null" block>切换</van-button>
					<van-button type="primary" @click="onSubmit" block style="margin-top: 10px;">登录</van-button>
					<van-button type="default" @click="reset" block style="margin-top: 10px;">重置</van-button>
				</div>
			</div>
		</template>
		<template v-else>
			<div class="box">
				<el-card class="box-card" style="padding-bottom: 20px;" v-if="!logincompany && appconfig.logincompany.length > 1">
					<div slot="header" class="clearfix">选择主体</div>
					<div>
						<el-button v-for="(item,index) in appconfig.logincompany" :key="index" plain style="width: 100%;margin: 0;margin-bottom: 10px;" @click="companyChange(item)">{{item.title}}</el-button>
					</div>
				</el-card>
				<el-card class="box-card" style="padding-bottom: 20px;" v-else>					
					<div slot="header" class="clearfix">
						<div class="flex" style="flex-direction: row;align-items: center;justify-content: center;">{{title}}</div>
					</div>
					<div style="box-sizing: border-box;padding-right: 60px;" ref="login_form"></div>
					<div style="margin-left: 80px;">
						<el-button v-if="appconfig.logincompany.length > 1" type="danger" @click="logincompany=null">切换</el-button>
						<el-button type="primary" @click="onSubmit">登录</el-button>
						<el-button @click="reset">重置</el-button>
					</div>
				</el-card>
			</div>
		</template>
	</div>
</template>
<style scoped>
	.login_container {
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.box {
		position: relative;
		width: 500px;
	}

	.phonebox {
		box-sizing: border-box;
		padding: 50px 20px;
	}

	.clearfix {
		text-align: center;
		font-size: 20px;

	}
</style>
<script>
	import {
		Loading
	} from 'element-ui';
	import dingtalkMixins from './mixins/dingtalk.js'
	import wecomMixins from './mixins/wecom.js'
	export default {
		mixins: [dingtalkMixins,wecomMixins],
		data() {
			return {
				logincompany:null,
				appconfig: window.config,
				title: window.config.title,
				loadhandle: null,
				getCodeUrl: '',
				getCodeSeed: Math.random(),
				show: true,
				formJson: {
					fApi: [],
					rule: [{
							type: "$input",
							field: "account",
							title: "账号",
							value: null,
							props: {
								inputAlign: 'left',
								placeholder: '请输入账号'
							},
							style: {
								"marginBottom": "20px"
							},
							validate: [{
								required: true,
								message: "必填项"
							}],
						},
						{
							type: "$input",
							field: "password",
							title: "密码",
							value: null,
							props: {
								inputprops: {
									type: 'password',
								},

								inputAlign: 'left',
								placeholder: '请输入密码'
							},
							style: {
								"marginBottom": "20px"
							},
							validate: [{
								required: true,
								message: "必填项"
							}]
						}
					],
					option: {
						form: {
							labelWidth: "80px",
							hideRequiredAsterisk: false,
							showMessage: false,
							inlineMessage: false
						},
						global: {
							"*": {
								props: {
									el: true,
									size: "large",
									disabled: false
								},
								col: {
									span: 24,
									offset: 0
								}
							},
							"el-divider": {
								wrap: {
									show: true
								},
								native: false,
								col: {
									span: 24,
									offset: 0
								},
								props: {
									contentPosition: "left"
								}
							}
						},
						submitBtn: false,
						resetBtn: false
					}
				},
				device: window.systemMethods.device()


			}
		},
		created() {
			if(window.config.logincompany.length == 1){
				this.logincompany = window.config.logincompany[0].company
			}
		},
		mounted() {
			if(!this.logincompany){
				let logincompany = this.getRedirectUri(window.location.href, 'logincompany')
				if(logincompany){
					let obj = window.config.logincompany.find((item)=>{
						return item.id == logincompany
					})
					if(obj){
						this.companyChange(obj)
					}
				}
			}else{
				let obj = window.config.logincompany.find((item)=>{
					return item.id == this.logincompany
				})
				if(obj){
					this.companyChange(obj)
				}
			}
		},
		methods: {
			companyChange(item){
				this.logincompany = item.company
				this.title = item.title
				window.config = {...window.config,...item}
				//console.log(window.config,123123)
				this.appconfig = window.config
				
				// this.wecomLogin()
				
				const ua = navigator.userAgent.toLowerCase()
				if(ua.indexOf('wxwork') !== -1 && this.appconfig.wecom){
					this.wecomLogin()
				}else if(this.appconfig.dingtalk){
					this.dingtalkLogin()
				}else{
					this.$nextTick(()=>{
						this.formCreate()
					})
				}
				
			},
			getRedirectUri(url, param) {
				let regex = new RegExp(`[?&]${param}=([^&#]*)`);
				let match = url.match(regex);
				return match ? decodeURIComponent(match[1]) : null;
			},
			authlogin(res){
				this.loadhandle = Loading.service({
					spinner: 'el-icon-loading',
					text: '',
					background: "rgba(255, 255, 255, 0.5)"
				})
				this.$api.login({
					account: res.account,
					password: res.password,
					authlogin: 1
				}).then((res) => {
					this.$store.commit('system/setSystemdata', res.systemdata)
					this.$store.commit('system/setUser', res.user)
					window.localStorage.setItem(this.$store.state.token, res.token)
					window.localStorage.setItem(this.$store.state.logincompany, this.logincompany)
					let redirect_uri = this.getRedirectUri(window.location.href, 'redirect_uri')
					if (redirect_uri) {
						window.location.href = redirect_uri
					} else {
						this.$emit('login', res)
					}
					this.loadhandle.close()
				}, () => {
					this.loadhandle.close()
				})
			},
			formCreate() {
				if (this.device != 'pc') {
					this.formJson.option.form.title = false
					this.formJson.option.form.labelWidth = '50px'
					this.formJson.option.global['*'].col.span = 24
				}
				this.formJson.option.el = this.$refs.login_form
				this.formJson.fApi = this.$formCreate(this.formJson.rule, this.formJson.option)
			},
			onSubmit() {
				
				this.formJson.fApi.submit((formData) => {
					this.loadhandle = Loading.service({
						spinner: 'el-icon-loading',
						text: '',
						background: "rgba(255, 255, 255, 0.5)"
					})
					this.$api.login(formData).then((res) => {
						this.$store.commit('system/setUser', res.user)
						window.localStorage.setItem(this.$store.state.token, res.token)
						window.localStorage.setItem(this.$store.state.logincompany, this.logincompany)
						let redirect_uri = this.getRedirectUri(window.location.href, 'redirect_uri')
						if (redirect_uri) {
							window.location.href = redirect_uri
						} else {
							this.$emit('login', res)
						}
						//this.$emit('login', res)
						setTimeout(()=>{
							this.loadhandle.close()
						},1000)
					}, () => {
						setTimeout(()=>{
							this.loadhandle.close()
						},1000)
					})
				}, () => {
					this.$message.error('缺少必填项')
				})

			},
			reset() {
				this.formJson.fApi.resetFields()
			},
			getCode() {
				this.getCodeSeed = Math.random()
			}
		}
	}
</script>